import { DeclinedReason } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
export interface DeclinedReasonsState extends EntityState<DeclinedReason> {}

export const declinedReasonsAdapter: EntityAdapter<DeclinedReason> = createEntityAdapter<DeclinedReason>({
  selectId: (declinedReason: DeclinedReason) => declinedReason.id,
});

export const initialState: DeclinedReasonsState = declinedReasonsAdapter.getInitialState();

export const declinedReasonsSelector = createSelector(
  svcDropdownsFeatureSelector,
  (state: any) => state.declinedReasons
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  declinedReasonsAdapter.getSelectors(declinedReasonsSelector);
